import api from './apifolder/index';
import StatesData from '../components/common/js/StatesData';
import { curUrl } from "./index"

/**
 * 获取接口所属页面页面名称
 * @returns 页面名称
 */
function getPageName() {
  const name = window.location.href.split('/').pop()
  const menuData = StatesData.statesData
  let pageName
  menuData.forEach((item) => {
    item.first_model.forEach((itemNext) => {
      if (!itemNext.name && itemNext.value === name) {
        pageName = itemNext.label
      } else if (itemNext.name) {
        itemNext.name.forEach((itemName) => {
          if (itemName.value === name) {
            pageName = itemName.label
          }
        })
      }
    })
  })
  // console.log(pageName, '获取页面名称');
  return pageName
}

/**
 * 操作行为上报
 * @param {*} response 接口响应体
 * @returns
 */
const operationPost = (response) => {
  // 上报接口不在上报, 防止循环
  const API = curUrl.xyxNewDataApi
  const operationAPI = `${API}/background/operation/report/`
  if (response.config.url === operationAPI) {
    return
  }
  let parameter
  if (!response.config.params && response.config.data === undefined) {
    parameter = '无'
  } else {
    if (Object.prototype.toString.call(response.config.data) !== '[object FormData]') {
      parameter = (response.config.params && response.config.data === undefined) ? response.config.params : JSON.parse(response.config.data)
    }
  }
  const href = window.location.hash.split('/');
  let gameId = 0
  href.forEach((item) => {
    if (!isNaN(Number(item))) {
      gameId = Number(item)
      // console.log('解析的game_id', Number(item));
    }
  })
  // console.log('全局接口拦截', response, window.location, gameId);
  const pageName = getPageName()
  const data = {
    game_id: gameId,
    operation: response.config.method,
    url: window.location.href,
    api: response.config.url,
    features: {
      platform: 'wxopapp',
      api_name: '',
      page_name: pageName,
      body: parameter,
    },
  }
  // console.log('行为上报信息', data);
  api.operationPost(data).then((res) => {
    console.log('上报成功之后', res.data.message);
  })
}

/**
 * 遍历数据, 返回不符合要求的字段(prop_id)数组
 * @param {*json} params 需要校验的数据
 * @param {*array} result 不符合要求的字段数组
 * @returns
 */
const analysisData = (params, result) => {
  const dataType = Object.prototype.toString;
  Object.keys(params).forEach((item) => {
    if (dataType.call(params[item]) === '[object Object]') {
      analysisData(params[item], result)
    } else if (dataType.call(params[item]) === '[object Array]') {
      const paramsArrItemLength = params[item].length
      if (paramsArrItemLength > 0) {
        const paramsArrItem = params[item]
        paramsArrItem.forEach((arrItem) => {
          if (dataType.call(arrItem) === '[object Object]') {
            analysisData(arrItem, result)
          }
        })
      }
    } else if (item === 'prop_id' && !params[item]) {
      result.push(item)
    }
  })
  return result
}


/**
 * 全局拦截非法道具(prop_id为空), 拦截post和patch接口
 * 对 request 中的 data 进行解析, 不符合要求的接口不予放行
 * @param {*request} request 接口的请求信息
 * @param {*source} source axios 取消请求方法
 * @returns Boolean
 */
const illegalProp = (request, source) => {
  // console.log('-= =- -= -= -= -=- =- =- =- =-= -= -=', request, source);
  // request 中 data 为 undefined 表示不是 post 或 patch 接口, 不需要拦截校验
  if (!request.data || request.data === undefined) {
    return true
  }
  request.cancelToken = source.token
  // console.log('request', request);
  const requestData = request.data
  const arr = analysisData(requestData, [])
  // console.log(analysisData(requestData, []));
  if (arr.length > 0) return false
  return true
}


export {
  illegalProp,
  operationPost,
  getPageName,
}
